// extracted by mini-css-extract-plugin
export default {"paginationNumbers":"PaginationNumberList_paginationNumbers__sjy7k","paginationButton":"PaginationNumberList_paginationButton__ktn+u","active":"PaginationNumberList_active__4mVXG"};